import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Menu } from "@mantine/core";

import { IconChevronDown } from "@tabler/icons-react";

import PractitionerContainer from "@/components/PractitionerContainer/PractitionerContainer";
import {
  LABOR_QUESTIONNAIRE_DISPLAY_NAMES,
  QuestionnaireTitle,
  QuestionnaireType,
} from "@/encounters/components/EncounterLabor/constants/labor-questionnaires";
import { EncounterLaborQuickButtonsProps } from "@/encounters/components/EncounterLabor/EncounterLabor/LaborMenu/EncounterLaborQuickButtons";
import { EncounterLaborQuickButtonDrawer } from "@/encounters/components/EncounterLabor/EncounterLaborDrawer/EncounterLaborQuickButtonDrawer";

const FLOW_SHEET_DROPDOWN_ITEMS = [
  {
    title: QuestionnaireTitle.FullLaborUpdate,
    questionnaireName: QuestionnaireType.FullLaborUpdate,
    displayTitle: LABOR_QUESTIONNAIRE_DISPLAY_NAMES[QuestionnaireType.FullLaborUpdate],
  },
  {
    title: QuestionnaireTitle.Membranes,
    questionnaireName: QuestionnaireType.Membranes,
    displayTitle: LABOR_QUESTIONNAIRE_DISPLAY_NAMES[QuestionnaireType.Membranes],
  },
  {
    title: QuestionnaireTitle.InputOutput,
    questionnaireName: QuestionnaireType.InputOutput,
    displayTitle: LABOR_QUESTIONNAIRE_DISPLAY_NAMES[QuestionnaireType.InputOutput],
  },
  {
    title: QuestionnaireTitle.MedsAndTherapies,
    questionnaireName: QuestionnaireType.MedsAndTherapies,
    displayTitle: LABOR_QUESTIONNAIRE_DISPLAY_NAMES[QuestionnaireType.MedsAndTherapies],
  },
  {
    title: QuestionnaireTitle.NewLocation,
    questionnaireName: QuestionnaireType.NewLocation,
    displayTitle: LABOR_QUESTIONNAIRE_DISPLAY_NAMES[QuestionnaireType.NewLocation],
  },
] as const;

type FlowSheet = (typeof FLOW_SHEET_DROPDOWN_ITEMS)[number];

export default function EncounterLaborMenuButton({
  encounterId,
  clientId,
}: EncounterLaborQuickButtonsProps) {
  const [opened, setOpened] = useState(false);
  const [selectedFlow, setSelectedFlow] = useState<FlowSheet | null>(null);
  const navigate = useNavigate();

  const handleMenuClick = (item: FlowSheet) => {
    if (item.questionnaireName === "fullLaborUpdate") {
      navigate(`/clients/${clientId}/encounters/${encounterId}/labor-assessment`);
    } else {
      setSelectedFlow(item);
      setOpened(true);
    }
  };

  return (
    <PractitionerContainer>
      <Menu data-testid="labor-menu-button">
        <Menu.Target>
          <Button
            variant="filled"
            color="burgundy"
            data-testid="labor-menu-button"
            rightSection={<IconChevronDown size={14} />}
          >
            Add to Flowsheet
          </Button>
        </Menu.Target>
        <Menu.Dropdown data-testid="labor-menu-dropdown">
          {FLOW_SHEET_DROPDOWN_ITEMS.map((item, index) => (
            <Fragment key={item.questionnaireName}>
              <Menu.Item
                onClick={() => handleMenuClick(item)}
                data-testid={`labor-menu-item-${item.questionnaireName}`}
              >
                {item.displayTitle}
              </Menu.Item>
              {index === 0 && <Menu.Divider />}
            </Fragment>
          ))}
        </Menu.Dropdown>
      </Menu>

      {selectedFlow && (
        <EncounterLaborQuickButtonDrawer
          opened={opened}
          clientId={clientId}
          encounterId={encounterId}
          onClose={() => setOpened(false)}
          questionnaireTitle={selectedFlow.displayTitle}
          questionnaireName={selectedFlow.questionnaireName}
        />
      )}
    </PractitionerContainer>
  );
}
